<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title">A<span class="small">UTHOR</span>’<span class="small">S</span> N<span class="small">OTE ON THE</span> P<span class="small">ARANORMAL</span></p>
<div class="image">
<p class="image-center"><img alt="img" src="images/P13-1.jpg"/></p>
<p class="caption">Author, ghost hunter and paranormal investigator Dennis Webster. <i>Photo by AOisthefuture</i>.</p>
</div>
<p class="noindent">I have been hunting ghosts with the Ghost Seekers of Central New York for over a decade and have walked many haunted theaters, mansions, graveyards and churches. I started out as a curious writer/author who was a skeptic and grew to realize ghosts are real and interact with the living. People will ask me questions about ghosts. Are they real? What are they? What happens to us in the afterlife? I’m also asked many other questions on what spirits are and what we will experience in the afterlife. Could it be that our souls forever drift after we are gone? Perhaps heaven awaits where we are with loved ones for eternity. Some theories are our souls are reincarnated and placed back into a fresh blank body in the womb. Ghosts might just be humans on the other side of a multiverse who are peeking through the veil at our experience. The truth is I don’t know. We will all know eventually when our carbon flesh husks fail and crumble to dust as our spirits rise. Only when we are among the dead will we know the truth. And perhaps at that point I’ll come haunt you and whisper in your sleeping ear the truth—but only if you’re open-minded enough to believe.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Authors_Note.vue?759d8a86